import { createIsomorphicFn } from "@tanstack/react-start";
import { defaultLocale } from "i18n";
import i18next from "i18next";

import { trpcClient } from "src/trpc";
import { type IsomorphicRequestData } from "src/types";

import { getAsyncContext } from "../getAsyncContext";

import { isomorphicRequestDataRef } from "./isomorphicRequestDataRef";

export const getIsomorphicRequestData: () => IsomorphicRequestData =
  createIsomorphicFn()
    .server(() => {
      const asyncContext = getAsyncContext();
      return asyncContext;
    })
    .client(() => {
      const data: IsomorphicRequestData = {
        locale: defaultLocale,
        i18n: i18next,
        trpc: trpcClient,
        posthogBootstrap: {},
        ...isomorphicRequestDataRef.current,
      };

      return data;
    });
